import qs from 'qs';

// Reg info from query string
// eslint-disable-next-line
const queryStringParams = qs.parse(window.location.search.substring(1)) as any;
// eslint-disable-next-line
const windowLF = (window as any)._lf;

export interface RegistrationQueryStringInfo {
  lf: string;
  token?: string;
  source?: string;
  firstname?: string;
  lastname?: string;
  email?: string;
  groupInvitation?: string;
  backBtn?: boolean;
  nextPage?: string;
  isMailfence: boolean;
  isMobileApp: boolean;
}

const lf = queryStringParams.lf || windowLF || 'netbusiness';
const source = queryStringParams.source || queryStringParams.src || undefined;
const sourceLower = source && source.toLowerCase();
const isMobileApp = sourceLower === 'ios_app' || sourceLower === 'android_app';

let displayBack = true;

if (queryStringParams.back === 'false' || queryStringParams.back === '0' || queryStringParams.Back === '0' || queryStringParams.Back === 'false') {
  displayBack = false;
}

const regInfo: RegistrationQueryStringInfo = {
  lf,
  backBtn: displayBack,
  nextPage: queryStringParams.nextPage || queryStringParams.nextpage,

  token: queryStringParams.token || undefined,
  source,
  firstname: queryStringParams.first_name || queryStringParams.firstname || '',
  lastname: queryStringParams.last_name || queryStringParams.lastname || '',
  email: queryStringParams.email || '',
  groupInvitation: queryStringParams.oi || undefined,
  isMailfence: lf.toLowerCase().indexOf('mailfence') >= 0,
  isMobileApp,
};

export default regInfo;
